// Utils
import Yup from "../../../utils/yup";

export default Yup.object().shape({
  paymentMethod: Yup.string().required("Required"),
});
